function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import * as c from './constants';
var initialState = {
  abstracts: [],
  pagination: {},
  status: {
    searchBusy: false,
    searchCompleted: false
  },
  viewedAbstracts: {}
};
export var abstractReducer = function abstractReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case c.ABSTRACT_SEARCH_REQUESTED:
      return _objectSpread(_objectSpread({}, state), {}, {
        status: _objectSpread(_objectSpread({}, state.status), {}, {
          searchBusy: true
        })
      });
    case c.ABSTRACT_SEARCH_COMPLETED:
      return _objectSpread(_objectSpread({}, state), {}, {
        abstracts: action.abstracts,
        pagination: action.pagination,
        status: _objectSpread(_objectSpread({}, state.status), {}, {
          searchBusy: false,
          searchCompleted: true
        })
      });
    case c.ABSTRACTS_UPDATED:
      return _objectSpread(_objectSpread({}, state), {}, {
        abstracts: state.abstracts.map(function (a) {
          return action.abstracts[a.identity] || a;
        })
      });
    case c.ABSTRACT_ARCHIVED:
      return _objectSpread(_objectSpread({}, state), {}, {
        abstracts: state.abstracts.filter(function (a) {
          return a.identity !== action.abstractIdentity;
        })
      });
    case c.ABSTRACT_VIEW_REQUESTED:
      return _objectSpread(_objectSpread({}, state), {}, {
        viewedAbstracts: _objectSpread(_objectSpread({}, state.viewedAbstracts), {}, _defineProperty({}, action.identity, {
          data: null,
          loading: true,
          error: false
        }))
      });
    case c.ABSTRACT_VIEW_COMPLETED:
      return _objectSpread(_objectSpread({}, state), {}, {
        viewedAbstracts: _objectSpread(_objectSpread({}, state.viewedAbstracts), {}, _defineProperty({}, action.identity, {
          data: action.abstract,
          loading: false,
          error: false
        }))
      });
    case c.ABSTRACT_VIEW_FAILED:
      return _objectSpread(_objectSpread({}, state), {}, {
        viewedAbstracts: _objectSpread(_objectSpread({}, state.viewedAbstracts), {}, _defineProperty({}, action.identity, {
          data: null,
          loading: false,
          error: true
        }))
      });
    default:
      return state;
  }
};
export default abstractReducer;